
// 接口域名
// const PREFIX = '//hr.posedu.cn/api';
const PREFIX = 'https://zstp.posedu.com.cn/api';
// 定义接口名称
const api = {
	'getFrontData': PREFIX + '/heilongjiang_api/getFrontData', //图谱数据
}
export default api;



// WEBPACK FOOTER //
// ./src/router/api.js